import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import ProjectForm from './ProjectForm';
import { useNavigate } from 'react-router-dom';

const ProjectList = () => {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await api.get('/projects');
      setProjects(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching projects:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      try {
        await api.delete(`/projects/${id}`);
        fetchProjects();
      } catch (error) {
        console.error('Error deleting project:', error);
        alert('Failed to delete project');
      }
    }
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingProject(null);
    fetchProjects();
  };

  if (loading) return <div className="loading">Loading projects...</div>;

  return (
    <div className="projects">
      <div style={{ marginBottom: '20px', marginLeft: '2rem' }}>
        <button 
          onClick={() => setShowForm(true)} 
          className="primary"
        >
          + New Project
        </button>
      </div>

      {showForm && (
        <ProjectForm 
          project={editingProject} 
          onClose={handleFormClose} 
        />
      )}

      <div className="card">
        <h3>All Projects</h3>
        {projects.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Floors</th>
                <th>Status</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {projects.map(project => (
                <tr key={project.id}>
                  <td>
                    <a 
                      href="#" 
                      onClick={(e) => { e.preventDefault(); navigate(`/projects/${project.id}`); }}
                      style={{ color: '#667eea', textDecoration: 'none', fontWeight: 'bold' }}
                    >
                      {project.name}
                    </a>
                  </td>
                  <td>
                    <td>
                      <span style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: '#e3f2fd',
                        color: '#1565c0'
                      }}>
                        {project.floors?.length || 0}
                      </span>
                    </td>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      background: project.status === 'active' ? '#d4edda' : '#f8d7da',
                      color: project.status === 'active' ? '#155724' : '#721c24'
                    }}>
                      {project.status}
                    </span>
                  </td>
                  <td>{new Date(project.created_at).toLocaleDateString()}</td>
                  <td>
                    <button 
                      onClick={() => handleEdit(project)} 
                      className="secondary"
                      style={{ marginRight: '10px' }}
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDelete(project.id)} 
                      className="danger"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No projects yet. Create your first project!</p>
        )}
      </div>
    </div>
  );
};

export default ProjectList;